export const FormErrors = {
  required: "Field is required.",
  minLength: "must choose at least one fabric.",
  maxLength:
    "the number of canopy sides is the maximum amount of fabrics that may be chosen. Please remove any extra fabrics.",
  arrayLenEven:
    "more than one fabric must be selected in groups of two; canopies have an event number of segments. Please add or remove a fabric.",
  email: "Please enter a valid email address.",
  phone: "Please enter a valid phone number.",
  stateReq: "Please enter a state."
};
